import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DatePicker, Input, Spin, TreeSelect, Pagination } from 'antd';
import moment from 'moment';

const tableList = (data, pageNo, startTime, endTime, dispatch) => {
  return data.map((item, index) => {
    let currentDate = new Date();
    return (
      <li key={index}>
        <div className="tip-case reportTable">
          <div className="meeting-index">{item.creatorDeptName}</div>
          <div className="meeting-area">{item.creatorName}</div>
          {false && <div className="meeting-name">{item.holderName}</div>}
          <div className="meeting-num">
            {Math.ceil((item.meetingLength / 60) * 100) / 100}
          </div>
          <div className="sign-num">{item.bookNum}</div>
          {/*<div className="meeting-occupy">{item.cancelNum}</div>*/}
          <div className="sign-length">{item.expireNum}</div>
          <div className="meeting-occupy">{item.earlyEndNum}</div>
          <div className="meeting-occupy">{item.extendNum}</div>
          <div
            className="meeting-detail"
            onClick={() => {
              dispatch({
                type: 'userAbnormallyDetails/clickToDetail',
                userSummary: item,
                startTime: startTime
                  ? startTime.valueOf()
                  : currentDate.getTime(),
                endTime: endTime ? endTime.valueOf() : currentDate.getTime()
              });
            }}
          >
            <FormattedMessage id="search_right_menu_details" />
          </div>
        </div>
      </li>
    );
  });
};
export default ({ intl, dispatch, loading, userReport, account }) => {
  let convertDeptTree = childDepts => {
    for (let i = 0; i < childDepts.length; i++) {
      let temp = childDepts[i];
      temp.label = temp.name;
      temp.value = temp.id + ',' + temp.name;
      temp.key = temp.id + ',' + temp.name;
      temp.children = temp.depts;
      if (temp.children.length > 0) {
        convertDeptTree(temp.children);
      }
    }
  };
  let treeData = account.allDeptList || [];
  convertDeptTree(treeData);

  const {
    startTime,
    endTime,
    userName,
    searchData,
    pageNo,
    pageSize,
    meetingSearchInfo,
    meetingTreeData
  } = userReport;
  const {
    meetingType,
    meetingDevice,
    moreMeeting = [],
    number = -1
  } = meetingSearchInfo;
  const meetingTree = meetingTreeData || { child: [] };
  return (
    <div className="message-body userreport report-room report-container">
      {/*<div className="messages-first">
        <div className="nav">
          <a>
            <FormattedMessage id="report_report" />/
            <FormattedMessage id="report_abnormal_user_statis" />
          </a>
        </div>
      </div>*/}
      <div className="user-report-container">
        <Spin spinning={loading} size="large">
          <div className="messages-list roomReport room-report-title">
            <div className="messages-title roomReport-head userReport">
              <div className="report-div report-area">
                <label className="report-search-label">
                  <FormattedMessage id="user_department" />
                </label>
                <div className="search-input">
                  <span className="menu-border">
                    <i className="iconfont icon-sousuo" />
                    <TreeSelect
                      // value={userReport.deptName}
                      className="user-select-tree"
                      dropdownStyle={{
                        maxHeight: 400,
                        overflow: 'auto',
                        minWidth: 200
                      }}
                      allowClear
                      treeData={treeData}
                      placeholder={intl.formatMessage({ id: 'pls_check_depart' })}
                      treeDefaultExpandAll
                      notFoundContent={intl.formatMessage({
                        id: 'user_dept_notFound'
                      })}
                      onChange={e => {
                        if (e) {
                          dispatch({
                            type: 'userAbnormallyReport/setState',
                            payload: { deptName: e, deptId: e.split(',')[0] }
                          });
                        } else {
                          dispatch({
                            type: 'userAbnormallyReport/setState',
                            payload: { deptName: '', deptId: '' }
                          });
                        }
                      }}
                    />
                  </span>
                </div>
              </div>
              <div className="report-div report-book-user">
                <label className="report-search-label">
                  <FormattedMessage id="report_user" />
                </label>
                <Input
                  placeholder={intl.formatMessage({
                    id: 'report_user_pls_name_f'
                  })}
                  value={userName}
                  onChange={e => {
                    dispatch({
                      type: 'userAbnormallyReport/setState',
                      payload: { userName: e.target.value }
                    });
                  }}
                />
              </div>
              <div className="report-div report-date">
                <label className="report-search-label" >
                  <FormattedMessage id="report_date" />
                </label>
                <div>
                  <DatePicker
                    allowClear={false}
                    value={startTime}
                    disabledDate={current => {
                      return (
                        current &&
                        current.startOf('day').valueOf() >=
                          endTime.startOf('day').valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'userAbnormallyReport/setState',
                        payload: { startTime: e }
                      });
                    }}
                  />
                  ~
                  <DatePicker
                    allowClear={false}
                    value={endTime}
                    disabledDate={current => {
                      return (
                        startTime.valueOf() > current.valueOf() ||
                        current.startOf('day').valueOf() >=
                          moment()
                            .startOf('day')
                            .valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'userAbnormallyReport/setState',
                        payload: { endTime: e }
                      });
                    }}
                  />
                </div>
              </div>
              <div className="report-div report-btn-group">
                <button
                  className="button_primary"
                  onClick={() => {
                    dispatch({ type: 'userAbnormallyReport/search' });
                  }}
                >
                  <FormattedMessage id="report_search" />
                </button>
                <button
                  onClick={() => {
                    dispatch({ type: 'userAbnormallyReport/downloadUser' });
                  }}
                >
                  <FormattedMessage id="report_download" />
                </button>
              </div>
            </div>
          </div>

          <div
            className="messages-list roomReport room-report-table"
            style={{ height: '620px' }}
          >
            <div className="tip-case reportTable">
              <div className="meeting-index">
                <FormattedMessage id="report_user_dept" />
              </div>
              <div className="meeting-area">
                <FormattedMessage id="report_user" />
              </div>
              {false && (
                <div className="meeting-name">
                  <FormattedMessage id="main_meeting_holder" />
                </div>
              )}
              <div className="meeting-num">
                <FormattedMessage id="main_meeting_time_length" />
              </div>
              <div className="sign-num">
                <FormattedMessage id="report_roomDetail_bookNum" />
              </div>
              {false && <div className="sign-length">未签到</div>}
              {/*<div className="meeting-occupy"><FormattedMessage id="report_roomDetail_cancelNum"/></div>*/}
              <div className="meeting-occupy">
                <FormattedMessage id="report_roomDetail_disuseNum" />
              </div>
              <div className="meeting-occupy">
                <FormattedMessage id="report_roomDetail_earlyNum" />
              </div>
              <div className="meeting-occupy">
                <FormattedMessage id="report_roomDetail_delayNum" />
              </div>
              <div className="meeting-detail">
                <FormattedMessage id="report_detail" />
              </div>
            </div>
            <ul
              className={
                searchData.list == undefined
                  ? ''
                  : searchData.list.length == 0
                    ? 'emptyData'
                    : 'messages'
              }
            >
              {searchData.list == undefined
                ? ''
                : searchData.list.length == 0
                  ? intl.formatMessage({ id: 'smart_device_drop_down_no_data' })
                  : ''}
              {searchData.list &&
                tableList(searchData.list, pageNo, startTime, endTime, dispatch)}
            </ul>
            <div className="page-cont">
              {searchData.total && searchData.total > 0 ? (
                <Pagination
                  total={searchData.total || 0}
                  showQuickJumper
                  showSizeChanger
                  pageSize={pageSize || 10}
                  current={pageNo || 1}
                  onShowSizeChange={(page, pageSize) => {
                    dispatch({
                      type: 'userAbnormallyReport/changePage',
                      payload: { pageNo: page, pageSize: pageSize}
                    });
                  }}
                  onChange={(page, pageSize) => {
                    dispatch({
                      type: 'userAbnormallyReport/changePage',
                      payload: { pageNo: page, pageSize: pageSize}
                    });
                  }}
                />
              ) : null}
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/UserReportAbnormally.js